let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gqA0p")).then(() => parcelRequire('3Q5Dp'));